import { FaSpinner } from "react-icons/fa";
import { useSelector } from "react-redux";

const FullScreenLoader = ({ text = "Please wait..." }) => {
    const component = useSelector((state) => state.component);

    if (!component?.contentLoading) return null;

    return (
        <div className="fullscreen-loader">
            <div className="loader-content">
                <FaSpinner size={45} className="loader-spinner" />
                <div className="loader-text">{text}</div>
            </div>
        </div>
    );
};

export default FullScreenLoader;
